<template>
    <div
        class="progress-indicator"
    >
        <img
            class="progress-image"
            src="@/assets/loader.svg"
        >
        <div class="percent-label">
            {{ percent }}% Complete
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProgressIndicator',
    props: {
        percent: {
            type: Number,
            required: true
        }
    }
};
</script>

<style scoped>
.progress-indicator {
    @apply flex flex-row items-end;
}

.progress-image {
    @apply mr-2;
    max-width: 50px;
    max-height: 50px;
}

.percent-label {
    @apply text-neutral-3 text-sm;
}
</style>
